import SearchAutocomplete from "./components/SearchAutocomplete.vue"
import SelectionCards from "./components/SelectionCards.vue"
import FilterableContentsList from "./components/FilterableContentsList.vue"
import BookContentsBrowser from "./components/BookContentsBrowser.vue"
import ContentPreview from "./components/ContentPreview.vue"
import WindowManager from "./components/WindowManager.vue"
import AdminContentsFilters from "./components/AdminContentsFilters.vue"
import ApiTesterPanel from "./components/ApiTesterPanel.vue"
import TranslationSideBySide from "./components/TranslationSideBySide.vue"
import HelpManual from "./components/HelpManual.vue"

/**
 * Registry of Vue components mountable via the vue-bridge Stimulus controller.
 * Add new components here when migrating interactive UI from Stimulus to Vue.
 */
const components = {
  SearchAutocomplete,
  SelectionCards,
  FilterableContentsList,
  BookContentsBrowser,
  AdminContentsFilters,
  ContentPreview,
  WindowManager,
  ApiTesterPanel,
  TranslationSideBySide,
  HelpManual,
}

export function getVueComponent(name) {
  const component = components[name]
  if (!component) {
    throw new Error(`Unknown Vue component: ${name}. Register it in app/javascript/vue/registry.js`)
  }
  return component
}

export default components
